import { type FC } from 'react';
import ExpandableFilterPanel from 'components/molecules/expandable-filter-panel';
import { useCallHistoryManagementFilters } from 'infrastructure/hooks/callHistoryManagement/useFilters';

import Body from './body';
import s from './styles.module.scss';

const CallHistoryManagementFilters: FC = () => {
  const { count, resetFilter } = useCallHistoryManagementFilters();
  return (
    <div className={s.wrapper}>
      <ExpandableFilterPanel filtersCount={count} onReset={resetFilter}>
        <Body />
      </ExpandableFilterPanel>
    </div>
  );
};

export default CallHistoryManagementFilters;
